var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "email_1_",
    "data-name": "email (1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.955,
    height: 14.196,
    viewBox: "0 0 18.955 14.196",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4682",
    "data-name": "Path 4682",
    d: "M11.061,176.67a2.851,2.851,0,0,1-3.168,0L.126,171.491Q.062,171.448,0,171.4v8.485a1.744,1.744,0,0,0,1.745,1.745H17.21a1.744,1.744,0,0,0,1.745-1.745V171.4c-.041.031-.083.061-.126.09Z",
    transform: "translate(0 -167.436)",
    fill: "#dadde5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4683",
    "data-name": "Path 4683",
    d: "M.742,67.4l7.767,5.178a1.74,1.74,0,0,0,1.936,0L18.212,67.4a1.663,1.663,0,0,0,.742-1.387,1.746,1.746,0,0,0-1.744-1.744H1.744A1.747,1.747,0,0,0,0,66.011,1.663,1.663,0,0,0,.742,67.4Z",
    transform: "translate(0 -64.266)",
    fill: "#dadde5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail1);
export default __webpack_public_path__ + "static/media/email (1).3b0e651fe32b559c64a79ade2cef57c2.svg";
export { ForwardRef as ReactComponent };